import { getAuthToken, Prayer } from "src/store/config";
import * as api from "./api";

interface ApiResponse {
  status: number;
  message: string;
  data: Prayer[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

// fetch list
export const fetchPrayerList = async (data: {
  search?: string;
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };
  if (data.search) {
    params.search = data.search; 
  }
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/prayer-musics`,
    params
  );
  return response;
};

// add prayer
export const addPrayer = async (params: {
  title: string;
  description: string;
  iconImage: string;
  audioUrl: string;
  audioDuration: string;
  pcid?: string;
}) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.post(
      `${process.env.REACT_APP_ADMIN_API_URL}/prayer-musics`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const updatePrayer = async (
  id: string,
  params: { title: string; description: string; iconImage: string; pcids?: string; audioUrl: string; audioDuration: string }
) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(
      `${process.env.REACT_APP_ADMIN_API_URL}/prayer-musics/${id}`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// delete prayer
export const deletePrayer = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(
    `${process.env.REACT_APP_ADMIN_API_URL}/prayer-musics/${id}`
  );
};
